module.exports =
`
# 业务合作

MUZIK Air 是全球最大古典音乐平台，弹指便可轻松享受音乐。透过 MUZIK Air 的悠扬丰富的音乐，您不只能接触到喜爱古典乐的人 们，更能透过我们的情境分类与社群新闻、富有生活情感的文章，接触到更多喜欢音乐跟生活结合的客户。现在就填写下列表单，我们的业务人员会洽谈您的需求。

`
